<template>
    <div class="enps-category-mode">
        <!-- Тулбар — в шапке САМОЙ ТАБЛИЦЫ, а не сверху вкладки: это фильтр конкретно текстового
             списка категорий, а не общий поиск по вкладке. Без чекбокса «Скрыть неактивных» —
             у категории нет понятия «активна/деактивирована» (в отличие от исполнителя/автора). -->
        <EnpsTableToolbar
            placeholder="Поиск по категории"
            :visible-count="filteredCategoryList.length"
            :total-count="categoryList.length"
            @input="searchQuery = $event"
        ></EnpsTableToolbar>

        <div class="enps-category-mode__row enps-category-mode__row_header">
            <span class="enps-category-mode__name">Категория</span>
            <span class="enps-category-mode__rating">Средняя оценка</span>
            <span class="enps-category-mode__count">Оценок</span>
        </div>

        <template v-for="category in filteredCategoryList">
            <div
                :key="`category-${category.categoryId}`"
                class="enps-category-mode__row"
                @click="toggleCategory(category)"
            >
                <span class="enps-category-mode__name">{{ category.categoryTitle }}</span>
                <span class="enps-category-mode__rating">{{ category.averageRating }}</span>
                <span class="enps-category-mode__count">{{ category.ratingsCount }}</span>
            </div>

            <div
                v-if="expandedCategoryId === category.categoryId"
                :key="`executors-${category.categoryId}`"
                class="enps-category-mode__executors"
            >
                <template v-if="isLoadingExecutors">
                    <VSpinner></VSpinner>
                </template>

                <template v-else>
                    <div
                        v-for="executor in executors"
                        :key="executor.accountId"
                        class="enps-category-mode__row enps-category-mode__row_executor"
                    >
                        <span class="enps-category-mode__name enps-category-mode__name_indented">{{
                            executor.displayName
                        }}</span>
                        <span class="enps-category-mode__rating">{{ executor.averageRating }}</span>
                        <span class="enps-category-mode__count">{{ executor.ratingsCount }}</span>
                    </div>
                    <div v-if="executors.length === 0" class="enps-category-mode__empty">Нет оценок</div>
                </template>
            </div>
        </template>

        <div v-if="categoryList.length === 0" class="enps-category-mode__empty enps-category-mode__empty_outer">
            Нет оценок за период
        </div>
        <div
            v-else-if="filteredCategoryList.length === 0"
            class="enps-category-mode__empty enps-category-mode__empty_outer"
        >
            По запросу ничего не найдено
        </div>
    </div>
</template>
<script>
// Components
import VSpinner from '@/views/components/VProgress/VSpinner.vue';
import EnpsTableToolbar from '@/views/components/EnpsTableToolbar.vue';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import http from '@/js/http';
import { matchesQuery } from '@/js/textSearch';

@Component({
    components: {
        VSpinner,
        EnpsTableToolbar,
    },
})
class EnpsCategoryModeTable extends Vue {
    @Prop({ type: Array, default: () => [] })
    categoryList;
    @Prop({ type: String, required: true })
    period;
    // Отдел, выбранный администратором на странице ('' — все) — drill-down обязан показывать
    // тот же срез, что и список категорий над ним.
    @Prop({ type: String, default: '' })
    department;

    // Поиск — только по названию категории; чекбокса «Скрыть неактивных» тут нет (см. тулбар в
    // шаблоне). Бар-чарт EnpsCategoryChart НЕ фильтруется этим же запросом и вообще не знает о
    // нём: тот график строится на серверных агрегатах top/rest (топ-N по числу оценок + свёрнутый
    // «остальные»), а не на списке ниже — применить к нему клиентский текстовый фильтр значило
    // бы либо фильтровать уже свёрнутую «Остальные N» пачку (бессмысленно — там нет отдельных
    // названий), либо тихо расходиться с тем, что показывает таблица под ним.
    searchQuery = '';

    expandedCategoryId = null;
    executors = [];
    isLoadingExecutors = false;

    get filteredCategoryList() {
        return this.categoryList.filter((category) => matchesQuery(category.categoryTitle, this.searchQuery));
    }

    toggleCategory(category) {
        if (this.expandedCategoryId === category.categoryId) {
            this.expandedCategoryId = null;
            return;
        }

        this.expandedCategoryId = category.categoryId;
        this.isLoadingExecutors = true;

        // Запрос уходит каждый раз (клиентский кэш убран решением владельца продукта — он
        // переживал только сессию вкладки, зато отдавал устаревшие цифры). Ответ применяется,
        // только если раскрыта всё ещё эта категория: при быстрых кликах по строкам поздний
        // ответ прежней категории не должен перетирать текущую.
        http.get(`/enps/dashboard/categories/${category.categoryId}/executors`, {
            params: { period: this.period, department: this.department },
        })
            .then(({ data }) => {
                if (this.expandedCategoryId !== category.categoryId) {
                    return;
                }

                this.executors = data;
            })
            .catch(() => {
                // Пустой список читался бы как «в категории нет оценок» — сворачиваем строку
                // обратно, повторный клик сделает новый запрос.
                if (this.expandedCategoryId === category.categoryId) {
                    this.executors = [];
                    this.expandedCategoryId = null;
                }
            })
            .finally(() => {
                if (this.expandedCategoryId === category.categoryId || this.expandedCategoryId === null) {
                    this.isLoadingExecutors = false;
                }
            });
    }

    @Watch('period')
    @Watch('department')
    onScopeChange() {
        // Раскрытый список исполнителей относится к старому периоду/отделу — проще свернуть,
        // чем тихо показывать устаревшие цифры; пользователь откроет категорию заново.
        this.expandedCategoryId = null;
    }
}

export default EnpsCategoryModeTable;
</script>
<style lang="scss">
.enps-category-mode {
    &__row {
        display: flex;
        padding: 10px 15px;
        cursor: pointer;
        border-bottom: 1px solid #e4eaef;

        &:hover {
            background-color: #f8f8f8;
        }

        &_header {
            font-weight: 600;
            cursor: default;

            &:hover {
                background-color: transparent;
            }
        }

        // Строка исполнителя внутри раскрытой категории — та же сетка колонок (см. &__name/
        // &__rating/&__count ниже), что и у строки категории/заголовка, иначе "Средняя оценка"
        // и "Оценок" съезжают относительно шапки таблицы. Не кликабельна — без cursor/hover.
        &_executor {
            cursor: default;

            &:hover {
                background-color: transparent;
            }
        }
    }

    &__name {
        flex: 1;

        // Отступ, обозначающий вложенность, — на содержимом первой ячейки, а не на строке/
        // контейнере целиком, иначе он сдвигает и колонки "Средняя оценка"/"Оценок" тоже.
        &_indented {
            padding-left: 30px;
        }
    }

    &__rating,
    &__count {
        width: 140px;
        text-align: right;
    }

    &__executors {
        padding: 4px 0;
        background-color: #fafafa;
    }

    &__empty {
        color: #a0a0a0;

        &_outer {
            padding: 20px 15px;
            text-align: center;
        }
    }
}
</style>
